export const scopes = {
  "Google Cloud": "Google Cloud",
  "google-cloud": "Google Cloud",
  "Amazon Web Services": "AWS",
  "amazon-web-services": "AWS",
};
